module.exports = __webpack_public_path__ + "img/iframe.684f665e.png";